export function classifyDailyBonusClaimResult(result) {
  if (result?.awarded === true) return "awarded";
  if (result?.reason === "already_claimed") return "already_claimed";
  return "not_awarded";
}
